import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  display: flex;
  height: 125px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.span`
  color: #456279;
  font-size: 14px;
`;
